import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import Typography from 'kingpin/atoms/Typography';

import { AgentKbContext } from './AgentKbProvider';
import ArtefactEditor from './ArtefactEditor';
import ValidationDrawer from './ValidationDrawer';

// One KB artefact (always-on prompt/terminology/workflow, or a reference topic)
// as a document: its editor, with the shared validation drawer underneath. The
// artefact is chosen by the nav (route param) — the old left ArtefactList is
// gone, its ordering now lives in the nav tree.

const PageDiv = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const EditorDiv = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const CenteredDiv = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const KbArtefactPage = () => {
  const { artefactId } = useParams<{ artefactId: string }>();
  const { artefacts, isLoading } = useContext(AgentKbContext);

  if (isLoading) {
    return (
      <CenteredDiv>
        <Typography.Body type="Body 13" color="var(--color-text-secondary)">
          Loading the knowledge base…
        </Typography.Body>
      </CenteredDiv>
    );
  }

  const artefact = artefacts.find((item) => item.id === artefactId);
  if (!artefact) {
    return (
      <CenteredDiv>
        <Typography.Body type="Body 13" color="var(--color-text-secondary)">
          This knowledge-base artefact no longer exists.
        </Typography.Body>
      </CenteredDiv>
    );
  }

  return (
    <PageDiv>
      <EditorDiv>
        <ArtefactEditor artefact={artefact} />
      </EditorDiv>
      <ValidationDrawer />
    </PageDiv>
  );
};

export default KbArtefactPage;
